export const staticData = [
  {
    id: "ASD-GSE-01CR01-PAC002",
    machine_health: "Observe",
    machine_name:
      "AIR COMPRESSOR 001-AIRSIDE-GROUND SERVICE EQUIPMENT MAINTENANCE FACILITY-LEVEL 01 PART E COMPRESSED AIR UNITS AREA 090 (C4800-01TR090)",
    location_id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
    machine_type_id: "555b1dc5-6983-4501-afdf-474665a3e131",
    manufacturer_name: null,
    model_name: null,
    attachments: null,
    start_operating_hour: null,
    end_operating_hour: null,
    machine_code: "33024",
    machine_brand: null,
    machine_model_no: "AIR COMPRESSOR-01",
    purchase_date: "2015-04-13",
    context: null,
    operational_mode: null,
    machine_power: null,
    machine_rpm_min: null,
    machine_rpm_max: null,
    maintenance_manpower: null,
    maintenance_frequency: null,
    warranty_date: null,
    iso_standard: null,
    machine_status: "Operational",
    MachineStrategies: [
      {
        id: "128f7ba2-2607-4e3c-b04b-d9eb1c218f76",
        financialStrategiesId: "7a9da5f1-4b4d-4935-96ff-4022e5a0e1fc",
        mark: "Default",
        machine_id: "ASD-GSE-01CR01-PAC002",
        replacement_year: 2029,
        default_capex: 25000,
        parameters: {
          replacement: [
            {
              year: 2029,
              capex: 25000,
            },
          ],
        },
      },
    ],
    machine_elements: [],
    location: {
      id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
      location_name: "STANDBY POWER SUBSTATION",
      company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
      contact_person: "",
      contact_email: "",
      contact_number: "",
      location_address: "",
      parent_location_id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
      picture_url: null,
      location_machine_health: null,
      location_machine_health_last_updated: null,
      parent_location: {
        id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
        location_name: "MATAR - Hamad International Airport",
        company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
        contact_person: null,
        contact_email: null,
        contact_number: "undefined",
        location_address: null,
        parent_location_id: null,
        picture_url: null,
        location_machine_health: null,
        location_machine_health_last_updated: null,
        parent_location: null,
      },
    },
    machine_type: {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
  },
  {
    id: "ASD-GSE-03CR02-PAC003",
    machine_name:
      "AIR COMPRESSOR 901-AIRSIDE-GROUND SERVICE EQUIPMENT MAINTENANCE FACILITY-LEVEL 03 PART A COMPRESSOR ROOM 004 (C4800-03TR004)",
    location_id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
    machine_type_id: "555b1dc5-6983-4501-afdf-474665a3e131",
    machine_health: "Acceptable",
    manufacturer_name: null,
    model_name: null,
    attachments: null,
    start_operating_hour: null,
    end_operating_hour: null,
    machine_code: "36325",
    machine_brand: null,
    machine_model_no: "AIR COMPRESSOR-01",
    purchase_date: "2015-04-13",
    context: null,
    operational_mode: null,
    machine_power: null,
    machine_rpm_min: null,
    machine_rpm_max: null,
    maintenance_manpower: null,
    maintenance_frequency: null,
    warranty_date: null,
    iso_standard: null,
    machine_status: "Operational",
    MachineStrategies: [
      {
        id: "7cf65f44-d55b-426b-893b-0abff2eb46bc",
        financialStrategiesId: "7a9da5f1-4b4d-4935-96ff-4022e5a0e1fc",
        mark: "Default",
        machine_id: "ASD-GSE-03CR02-PAC003",
        replacement_year: 2030,
        default_capex: 25000,
        parameters: {
          replacement: [
            {
              year: 2030,
              capex: 25000,
            },
          ],
        },
      },
    ],
    machine_elements: [],
    location: {
      id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
      location_name: "STANDBY POWER SUBSTATION",
      company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
      contact_person: "",
      contact_email: "",
      contact_number: "",
      location_address: "",
      parent_location_id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
      picture_url: null,
      location_machine_health: null,
      location_machine_health_last_updated: null,
      parent_location: {
        id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
        location_name: "MATAR - Hamad International Airport",
        company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
        contact_person: null,
        contact_email: null,
        contact_number: "undefined",
        location_address: null,
        parent_location_id: null,
        picture_url: null,
        location_machine_health: null,
        location_machine_health_last_updated: null,
        parent_location: null,
      },
    },
    machine_type: {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
  },
  {
    id: "LSD-MWB-01WK13-PAC004",
    machine_name:
      "AIR COMPRESSOR 001-LANDSIDE-MAINTENANCE WORKSHOP BUILDING-LEVEL 01 COMPRESSOR ROOM 052 (C4310-01TR052)",
    location_id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
    machine_type_id: "555b1dc5-6983-4501-afdf-474665a3e131",
    machine_health: "Acceptable",
    manufacturer_name: null,
    model_name: null,
    attachments: null,
    start_operating_hour: null,
    end_operating_hour: null,
    machine_code: "122931",
    machine_brand: null,
    machine_model_no: "AIR COMPRESSOR-01",
    purchase_date: "2015-04-14",
    context: null,
    operational_mode: null,
    machine_power: null,
    machine_rpm_min: null,
    machine_rpm_max: null,
    maintenance_manpower: null,
    maintenance_frequency: null,
    warranty_date: null,
    iso_standard: null,
    machine_status: "Operational",
    MachineStrategies: [
      {
        id: "8a564966-6504-404b-b71e-b0e95a156958",
        financialStrategiesId: "7a9da5f1-4b4d-4935-96ff-4022e5a0e1fc",
        mark: "Default",
        machine_id: "LSD-MWB-01WK13-PAC004",
        replacement_year: 2037,
        default_capex: 25000,
        parameters: {
          replacement: [
            {
              year: 2037,
              capex: 25000,
            },
          ],
        },
      },
    ],
    machine_elements: [],
    location: {
      id: "8fb0ac7c-19d6-4b16-9f64-b26f12781cb3",
      location_name: "STANDBY POWER SUBSTATION",
      company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
      contact_person: "",
      contact_email: "",
      contact_number: "",
      location_address: "",
      parent_location_id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
      picture_url: null,
      location_machine_health: null,
      location_machine_health_last_updated: null,
      parent_location: {
        id: "0bb46a17-5cac-4317-a343-9d1d4261cdf3",
        location_name: "MATAR - Hamad International Airport",
        company_id: "82f684e1-6847-42e6-a93d-c0a19c9ed6ae",
        contact_person: null,
        contact_email: null,
        contact_number: "undefined",
        location_address: null,
        parent_location_id: null,
        picture_url: null,
        location_machine_health: null,
        location_machine_health_last_updated: null,
        parent_location: null,
      },
    },
    machine_type: {
      id: "555b1dc5-6983-4501-afdf-474665a3e131",
      name: "Compressor",
    },
  },
];
